import { Component } from '@angular/core';

/**
 * Painel de marca exibido à esquerda nas telas de autenticação (login, esqueci a senha,
 * redefinir senha). Some abaixo de 992px — nesse caso o AuthLayoutComponent mostra a logo
 * na barra superior e um rodapé compacto.
 */
@Component({
  selector: 'app-auth-brand-panel',
  standalone: true,
  templateUrl: './auth-brand-panel.component.html',
  styleUrl: './auth-brand-panel.component.css',
})
export class AuthBrandPanelComponent {}
